<script lang="ts" setup>
import { useResourcesDialogStore } from '~/store/resourcesDialog';
const resourcesDialogStore = useResourcesDialogStore();

const getResourcePath = (resourceType: string, resourceId: string) => {
  switch (resourceType) {
    case 'operator':
      return `/operators/${resourceId}`;
    case 'map':
      return `/table-maps/${resourceId}`;
    case 'device':
      return `/devices/${resourceId}`;
    case 'order_charge':
      return `/order-charges/${resourceId}`;
    case 'table_charge':
      return `/table-charges/${resourceId}`;
    case 'order_layout':
      return `/order-layouts/${resourceId}`;
    case 'course':
      return `/courses/${resourceId}`;
    case 'coupon':
      return `/coupons/${resourceId}`;
    case 'discount':
      return `/discounts/${resourceId}`;
    case 'printer':
      return `/printers/${resourceId}`;
    default:
      return '/';
  }
};
</script>

<template>
  <m-dialog
    v-model="resourcesDialogStore.dialog"
    :width="resourcesDialogStore.option.width"
    @keydown.esc="resourcesDialogStore.cancel"
  >
    <template #title>
      {{ resourcesDialogStore.title }}
    </template>

    <div style="white-space: pre-wrap; max-height: 60vh; overflow-y: auto">
      <div
        class="mb-2"
        v-if="resourcesDialogStore.message"
      >
        {{ resourcesDialogStore.message }}
      </div>
      <ul>
        <li
          v-for="(resourceList, resourceType) in resourcesDialogStore.resources"
          :key="resourceType"
        >
          {{ $t(`models.${resourceType}`) + ':' }}
          <span
            v-for="(resource, index) in resourceList"
            :key="index"
          >
            <nuxt-link
              :to="getResourcePath(String(resourceType), resource.id)"
              class="text-decoration-none"
            >
              {{ resource.name || resource.id }}
            </nuxt-link>
            {{ index === resourceList.length - 1 ? '' : ', ' }}
          </span>
        </li>
      </ul>
    </div>
    <template #actions>
      <m-btn
        v-if="!resourcesDialogStore.option.noCancel"
        variant="outlined"
        @click="resourcesDialogStore.cancel"
      >
        {{ $t('buttons.cancel') }}
      </m-btn>

      <m-btn
        :color="resourcesDialogStore.option.confirmColor"
        @click="resourcesDialogStore.agree"
      >
        {{ resourcesDialogStore.option.confirmText }}
      </m-btn>
    </template>
  </m-dialog>
</template>

<style scoped>
div {
  word-break: break-word;
}
ul {
  list-style-type: disc;
  padding-left: 20px;
}
</style>
